// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2mSB3","row":"Node_row__15q6Q","label":"Node_label__3DJe3","footer":"Node_footer__3gXeg"};